module.exports = __webpack_public_path__ + "static/media/logo_inyo.84190f12.png";